@if (workbenchTasksEnabled) {
<div [style.padding-top]="updatedTableDesignEnabled ? null : '23px'" [style.padding-bottom]="updatedTableDesignEnabled ? null : '20px'">
    <div class="flex flex-row">
        <h2 class="title">Requirements</h2>
        <mrs-btn-icon class="float-end" style="margin-left: auto;" iconName="add" buttonLabel="Add Requirements" buttonId="addButton"      
            *ngIf="addMultipleRequirementsIsEnabled" [disabled]="requirements.length === 0 || baseProps.readonly" (onClick)="openAddCaseRequirementModal()">
        </mrs-btn-icon>  
    </div>
    <ng-container *ngIf="!baseProps.integrationRequirementsLoaded || !requirementsLoaded || !caseIntegrationQueueEntriesLoaded">
        <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
    </ng-container>

    <ng-container *ngIf="baseProps.integrationRequirementsLoaded && requirementsLoaded && caseIntegrationQueueEntriesLoaded">

        <uw-requirements-expand-table
            [baseProps]="baseProps"
            [caseRequirements]="caseRequirements"
            [requirements]="requirements"
            (onMenuAction)="handleCaseRequirementAction($event)">
        </uw-requirements-expand-table>

        <uw-requirements-add-form *ngIf="!addMultipleRequirementsIsEnabled" [baseProps]="baseProps" [caseRequirements]="caseRequirements"></uw-requirements-add-form>
        

    </ng-container>
</div>
}
@else {
    <div style="padding-top: 23px; padding-bottom: 20px">
    <h2 class="title">Requirements</h2>

    <ng-container *ngIf="!baseProps.integrationRequirementsLoaded || !requirementsLoaded || !caseIntegrationQueueEntriesLoaded">
        <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
    </ng-container>

    <ng-container *ngIf="baseProps.integrationRequirementsLoaded && requirementsLoaded && caseIntegrationQueueEntriesLoaded">

        <uw-requirements-expand-table
            [baseProps]="baseProps"
            [caseRequirements]="caseRequirements"
            [requirements]="requirements"
            (onMenuAction)="handleCaseRequirementAction($event)">
        </uw-requirements-expand-table>

        <uw-requirements-add-form *ngIf="!addMultipleRequirementsIsEnabled" [baseProps]="baseProps" [caseRequirements]="caseRequirements"></uw-requirements-add-form>
        
        <button mat-raised-button color="primary" *ngIf="addMultipleRequirementsIsEnabled" [disabled]="requirements.length === 0 || baseProps.readonly" (click)="openAddCaseRequirementModal()">
            <mat-icon aria-hidden="false" aria-label="add icon" matSuffix>
                add
            </mat-icon>
            Add Requirements
        </button>
    </ng-container>
</div>
}